import React from 'react'

import { ColumnContent } from './ColumnContent.react'
import { ColumnHeader } from './ColumnHeader.react'
import { Container } from '../layout/Container.react'
import { Row } from '../layout/Row.react'

export const BasicTable = ({ headers = [], columns = [], data, changeSortFn = null, isAscending = null, isDescending = null }) => {
  const rowHeaders = headers.map(headerDefinition =>
    headerDefinition.sortBy
      ? { changeSortFn, isAscending, isDescending, ...headerDefinition }
      : headerDefinition
  )

  return (
    <div role='table'>
      <Row tableRow tableHeader role='rowgroup'>
        <Container>
          <Row>
            {rowHeaders.map((headerDef, columnIndex) => <ColumnHeader key={'ColumnHeader' + `${columnIndex}-${headerDef.title}`} {...headerDef} />)}
          </Row>
        </Container>
      </Row>
      <div role='rowgroup'>
        {data.map((result, rowIndex) =>
          <Row tableRow tableContent striped role='row' key={rowIndex}>
            <Container>
              <Row>
                {columns.map((columnDefinition, columnIndex) =>
                  <ColumnContent result={result} key={'ColumnContent' + columnIndex} {...columnDefinition} />
                )}
              </Row>
            </Container>
          </Row>
        )}
      </div>
    </div>
  )
}
